import { useMemo } from 'react';

import type { Notification } from 'entities/notification';

import { isNotificationRead } from '../lib/is-notification-read';
import { isNotificationUrgent } from '../lib/is-notification-urgent';

export const useNotifications = (data: Notification[] | undefined) => {
  const allNotifications = useMemo(() => {
    return data ?? [];
  }, [data]);

  const urgentNotifications = useMemo(() => allNotifications.filter(isNotificationUrgent), [allNotifications]);

  const hasUnreadNotifications = useMemo(
    () => allNotifications.some(notification => !isNotificationRead(notification)),
    [allNotifications]
  );

  return {
    allNotifications,
    urgentNotifications,
    hasUnreadNotifications
  };
};
